export const DOCSEARCH_CONTENT_URL = 'https://cdn.jsdelivr.net/npm/docsearch.js@2.6.3/dist/cdn/docsearch.min.js'
export const DOCSEARCH_STYLESHEET_URL = 'https://cdn.jsdelivr.net/npm/docsearch.js@2.6.3/dist/cdn/docsearch.min.css'
